import { useRecordingSettingsStore } from "@/store/recordingSettings.store";
import { Switch } from "@/components/ui/switch";
import { TooltipHelp } from "@/components/ui/TooltipHelp";
import { Label } from "@/components/ui/label";
import { TranscriptionProviderName } from "@/hooks/transcriber/types";
import { t } from "i18next";

export const SwitchTranscriptionRealtime = (): JSX.Element => {
  const {
    isRealtimeEnabled,
    saveIsRealtimeEnabled,
    diarize,
    saveDiarize,
    transcriptionProvider,
    transcriptionNoRealtimeProvider,
  } = useRecordingSettingsStore();

  const isDeepgramSelected = isRealtimeEnabled
    ? transcriptionProvider === TranscriptionProviderName.DEEPGRAM
    : (transcriptionNoRealtimeProvider?.startsWith("deepgram/") ?? false);

  return (
    <div className="flex flex-col w-full gap-4">
      <div className="flex flex-row items-center justify-end gap-2">
        <span className="text-tinted-grey-3 text-sm">
          {t("components.switchTranscriptionRealtime.title")}
        </span>
        <Switch
          checked={isRealtimeEnabled}
          onCheckedChange={(checked) => {
            saveIsRealtimeEnabled(checked);
          }}
        />
      </div>
      {/* Speaker Diarization - show for Deepgram (both realtime and non-realtime) */}
      {isDeepgramSelected && (
        <div className="flex items-center justify-end gap-2">
          <Label className="text-tinted-grey-3 text-sm">
            {t("components.advancedSettings.optionDiarization.label")}
          </Label>
          <Switch
            checked={diarize}
            onCheckedChange={(checked) => {
              saveDiarize(checked);
            }}
          />
          <TooltipHelp
            content={t("components.advancedSettings.optionDiarization.tooltip")}
          />
        </div>
      )}
    </div>
  );
};
